<div class="userhistoryDialogue mTab">
  <mat-tab-group mat-stretch-tabs="false" [selectedIndex]="0">
    <mat-tab>
      <ng-template mat-tab-label>
        Change Log
      </ng-template>
      @if (data.element.Name && data.dataType == 'ExcellenceLever') {
        <div>
          <span class="title">Excellence Lever Name:</span> {{data.element.Name}} <br>
        </div>
      }
      @if (data.element.LineOfBusiness && data.dataType == 'ExcellenceLever') {
        <div>
          <span class="title">Line Of Business:</span> {{data.element.LineOfBusiness}} <br>
        </div>
      }
      @if (data.element.Function && data.dataType == 'ExcellenceLever') {
        <div>
          <span class="title">Function:</span> {{data.element.Function}} <br>
        </div>
      }
      @if (data.element.ExcellenceLever && data.dataType == 'ExcellenceLeverKpi') {
        <div>
          <span class="title">Excellence Lever:</span> {{data.element.ExcellenceLever}} <br>
        </div>
      }
      @if (data.element.AccountId && data.dataType == 'ExcellenceLeverKpi') {
        <div>
          <span class="title">Account Id:</span> {{data.element.AccountId}} <br>
        </div>
      }
      @if (data.element.Name && data.dataType == 'ExcellenceFactor') {
        <div>
          <span class="title">Excellence Factor Name:</span> {{data.element.Name}} <br>
        </div>
      }
      @if (data.element.Description && data.dataType == 'ExcellenceFactor') {
        <div>
          <span class="title">Excellence Factor Description:</span> {{data.element.Description}} <br>
        </div>
      }
      @if (data.element.ExcellenceLever && data.dataType == 'ExcellenceFactor') {
        <div>
          <span class="title">Excellence Lever:</span> {{data.element.ExcellenceLever}} <br>
        </div>
      }
      @if (data.element.Name && data.dataType == 'Wave') {
        <div>
          <span class="title">Wave Name:</span> {{data.element.Name}} <br>
        </div>
      }
      @if (data.element.StartDate && data.dataType == 'Wave') {
        <div>
          <span class="title">Wave Start Date:</span> {{data.element.StartDate}} <br>
        </div>
      }
      @if (data.element.EndDate && data.dataType == 'Wave') {
        <div>
          <span class="title">Wave End Date:</span> {{data.element.EndDate}} <br>
        </div>
      }
      @if (data.element.ExcellenceLeverName && data.dataType == 'WaveExcellenceLeverConfiguration') {
        <div>
          <span class="title">Excellence Lever:</span> {{data.element.ExcellenceLeverName}} <br>
        </div>
      }
      @if (data.element.MgmtId && data.dataType == 'AssesmentAssignment') {
        <div>
          <span class="title">Branch Id:</span> {{data.element.MgmtId}} <br>
        </div>
      }
      @if (data.element.MgmtName && data.dataType == 'AssesmentAssignment') {
        <div>
          <span class="title">Branch Name:</span> {{data.element.MgmtName}} <br>
        </div>
      }
      @if (data.element.AssessmentDate && data.dataType == 'AssesmentAssignment') {
        <div>
          <span class="title">Assessment Date:</span> {{data.element.AssessmentDate}} <br>
        </div>
      }
      @if (data.element.ContactName && data.dataType == 'BranchContact') {
        <div>
          <span class="title">Contact Name:</span> {{data.element.ContactName}} <br>
        </div>
      }
      @if (data.element.ContactEmail && data.dataType == 'BranchContact') {
        <div>
          <span class="title">Contact Email:</span> {{data.element.ContactEmail}} <br>
        </div>
      }
      @if (data.element.ContactCategory && data.dataType == 'BranchContact') {
        <div>
          <span class="title">Contact Category:</span> {{data.element.ContactCategory}} <br>
        </div>
      }
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mat-table-custom" matSort>
        <ng-container matColumnDef="CreatedBy">
          <th mat-header-cell *matHeaderCellDef> Created By </th>
          <td mat-cell *matCellDef="let element">
            <p class="overflow-ellipsis">{{element.CreatedBy}}</p>
          </td>
        </ng-container>
        <ng-container matColumnDef="CreatedAtUtc">
          <th mat-header-cell *matHeaderCellDef> Created At (UTC) </th>
          <td mat-cell *matCellDef="let element">
            <p>{{element.CreatedAtUtc | date:'yyyy-MM-dd HH:mm'}}</p>
          </td>
        </ng-container>
        <ng-container matColumnDef="ChangedBy">
          <th mat-header-cell *matHeaderCellDef> Changed By </th>
          <td mat-cell *matCellDef="let element">
            <p class="overflow-ellipsis">{{element.ChangedBy}}</p>
          </td>
        </ng-container>
        <ng-container matColumnDef="ChangedAtUtc">
          <th mat-header-cell *matHeaderCellDef> Changed At (UTC) </th>
          <td mat-cell *matCellDef="let element">
            <p>{{element.ChangedAtUtc | date:'yyyy-MM-dd HH:mm'}}</p>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
      </table>
    </mat-tab>
  </mat-tab-group>

  <br />
  <div style="text-align:center">
    <button mat-raised-button class="btn button-color-fix-red " (click)="close()">
      <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
      Back
    </button>
  </div>
  <br />
</div>